/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Quick_Action_SublineInputs */

const de_notifications_quick_action_subline = /** @type {(inputs: Notifications_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail- und Push-Benachrichtigungen verwalten`)
};

/** @type {(inputs: Notifications_Quick_Action_SublineInputs) => LocalizedString} */
const en_notifications_quick_action_subline = de_notifications_quick_action_subline;

/**

* @param {Notifications_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_quick_action_subline = /** @type {((inputs?: Notifications_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_quick_action_subline(inputs)
	return en_notifications_quick_action_subline(inputs)
});